import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button } from './ui/button'
import { pagePanel } from './layout/page-styles'
import { cn } from '../lib/utils'

export function NotFound() {
  const { t } = useTranslation()

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-page p-4">
      <div className={cn(pagePanel, 'w-full max-w-md p-8')}>
        <div className="text-center">
          <div className="text-5xl font-bold text-neutral-200 mb-4">{t('notFound.code')}</div>
          <h1 className="text-lg font-semibold text-neutral-900 mb-2">{t('notFound.title')}</h1>
          <p className="text-sm text-neutral-500 mb-6">
            {t('notFound.message')}
          </p>
          <div className="flex gap-3 justify-center">
            <Link to="/">
              <Button variant="primary" size="md">{t('common.backToHome')}</Button>
            </Link>
            <Button onClick={() => window.history.back()} variant="secondary" size="md">
              {t('common.back')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
